/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_FullInputs */

const en_pricing_compare_full = /** @type {(inputs: Pricing_Compare_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full DACH`)
};

const de_pricing_compare_full = /** @type {(inputs: Pricing_Compare_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständig DACH`)
};

const fr_pricing_compare_full = /** @type {(inputs: Pricing_Compare_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH complet`)
};

const es_pricing_compare_full = /** @type {(inputs: Pricing_Compare_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH completo`)
};

const it_pricing_compare_full = /** @type {(inputs: Pricing_Compare_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH completo`)
};

const nl_pricing_compare_full = /** @type {(inputs: Pricing_Compare_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledig DACH`)
};

const pl_pricing_compare_full = /** @type {(inputs: Pricing_Compare_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełne DACH`)
};

const fi_pricing_compare_full = /** @type {(inputs: Pricing_Compare_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täydellinen DACH`)
};

const da_pricing_compare_full = /** @type {(inputs: Pricing_Compare_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuld DACH`)
};

const sv_pricing_compare_full = /** @type {(inputs: Pricing_Compare_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullständig DACH`)
};

/**
* | output |
* | --- |
* | "Full DACH" |
*
* @param {Pricing_Compare_FullInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_full = /** @type {((inputs?: Pricing_Compare_FullInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_FullInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_full(inputs)
	if (locale === "fr") return fr_pricing_compare_full(inputs)
	if (locale === "es") return es_pricing_compare_full(inputs)
	if (locale === "it") return it_pricing_compare_full(inputs)
	if (locale === "nl") return nl_pricing_compare_full(inputs)
	if (locale === "pl") return pl_pricing_compare_full(inputs)
	if (locale === "fi") return fi_pricing_compare_full(inputs)
	if (locale === "da") return da_pricing_compare_full(inputs)
	if (locale === "sv") return sv_pricing_compare_full(inputs)
	return en_pricing_compare_full(inputs)
});